import { Content } from 'mdello-client-ts/dist/src/types/mdello/cms.type';
import { useQuery, useQueryClient } from 'react-query';
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum';

export const useGetContentDraftMap = () => {
  const queryClient = useQueryClient();
  // Use useQuery to get the local data
  return useQuery(QueryKey.CONTENT_DRAFT_MAP, (): Content<any>[] | [] => {
    // Read the data from the query cache
    return queryClient.getQueryData(QueryKey.CONTENT_DRAFT_MAP) || [];
  });
};
